<!--
 * @Author: YuanYuan
 * @Date: 2024-02-28 09:39:22
 * @LastEditTime: 2024-02-28 09:55:35
 * @description: 查询条件中输入框控件
-->
<template>
  <el-input v-bind="attrs" v-on="$listeners">
    <span slot="prefix">{{label}}{{$t('common.colon')}}</span>
  </el-input>
</template>

<script setup>
import { toRefs, computed, getCurrentInstance } from 'vue'
import { assign } from 'lodash-es'

const $vm = getCurrentInstance().proxy

const props = defineProps({
  label: {
    type: String,
    default: '-'
  }
})
const defaultAttrs = {
  clearable: true
}
const attrs = computed(() => (assign(
  $vm.$attrs,
  defaultAttrs
)))

const { label } = toRefs(props)

</script>
